import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceSmile } from "@fortawesome/pro-regular-svg-icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import ReactionQuickBar from "./ReactionQuickBar";
import { ReactionLabels } from "./reactions";

type Props = {
  currentEmoji?: string;
  onSelect: (emoji: string) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  labels: ReactionLabels;
};

// "React" trigger styled like the sibling interaction buttons (Interessant /
// Teilen): a normal btn with the face-smile icon + label. Clicking opens the
// emoji quick-bar in a popover. In the app it stays icon-only (xl), matching the
// other app interaction buttons.
export default function ReactionButton({
  currentEmoji,
  onSelect,
  open,
  onOpenChange,
  labels,
}: Props) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={labels.addReaction}
          className={classNames("btn btn-sm", { "btn-light": !window.isApp })}
        >
          <FontAwesomeIcon
            className="mr-1 text-primary"
            icon={faFaceSmile}
            size={window.isApp ? "xl" : undefined}
          />
          {!window.isApp && labels.addReaction}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        className="w-auto border-none bg-transparent p-0 shadow-none"
      >
        <ReactionQuickBar
          currentEmoji={currentEmoji}
          labels={labels}
          onSelect={(emoji) => {
            onSelect(emoji);
            onOpenChange(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
